import { AuthState } from 'app/dux/session/types';

export function buildFetchDefaultsFromAuthState(authState: AuthState) {
    const accessToken = authState.delegate.access_token || authState.access_token;
    return {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'company-id': authState.delegate.claims.company_id || authState.claims.company_id,
            'person-id': authState.claims.person_id,
        }
    };
}

